/**
 * @generated SignedSource<<259a343a1bd64d52149a68e3e9a84917>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type NumberTaskUnit = "CURRENCY" | "CUSTOM";
export type RecurrenceFrequency = "DAILY" | "MONTHLY" | "WEEKLY" | "YEARLY";
export type RoutineType = "DEFAULT" | "EVENT_ITEM" | "KPI" | "STANDARD" | "TEMPLATE";
import { FragmentRefs } from "relay-runtime";
export type WidgetTaskSingleNumberOccasionPage_taskNumber$data = {
  readonly id: string;
  readonly occasions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly occasion: {
          readonly endAt: string;
          readonly id: string;
          readonly sequenceNumber: number;
          readonly startAt: string;
        };
        readonly taskExecutions: ReadonlyArray<{
          readonly goals: {
            readonly greaterThan: number | null;
            readonly lessThan: number | null;
          } | null;
          readonly numberValue: number | null;
          readonly sectionId: string;
          readonly updatedAt: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"useGroupNumberTaskExecution_taskExecutionNumber">;
        }>;
      };
    }>;
  };
  readonly routine: {
    readonly id: string;
    readonly schedule: {
      readonly rules: ReadonlyArray<{
        readonly freq: RecurrenceFrequency;
      }>;
    } | null;
    readonly title: string;
    readonly type: RoutineType;
  };
  readonly title: string;
  readonly unit: NumberTaskUnit;
  readonly " $fragmentType": "WidgetTaskSingleNumberOccasionPage_taskNumber";
};
export type WidgetTaskSingleNumberOccasionPage_taskNumber$key = {
  readonly " $data"?: WidgetTaskSingleNumberOccasionPage_taskNumber$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTaskSingleNumberOccasionPage_taskNumber">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTaskSingleNumberOccasionPage_taskNumber",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unit",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Routine",
      "kind": "LinkedField",
      "name": "routine",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Schedule",
          "kind": "LinkedField",
          "name": "schedule",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecurrenceRule",
              "kind": "LinkedField",
              "name": "rules",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "freq",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 8
        }
      ],
      "concreteType": "TaskNumberOccasionConnection",
      "kind": "LinkedField",
      "name": "occasions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TaskNumberOccasionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TaskNumberOccasion",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RoutineOccasion",
                  "kind": "LinkedField",
                  "name": "occasion",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sequenceNumber",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TaskExecutionNumber",
                  "kind": "LinkedField",
                  "name": "taskExecutions",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "numberValue",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sectionId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "TaskNumberGoals",
                      "kind": "LinkedField",
                      "name": "goals",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "lessThan",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "greaterThan",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "useGroupNumberTaskExecution_taskExecutionNumber"
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "occasions(first:8)"
    }
  ],
  "type": "TaskNumber",
  "abstractKey": null
};
})();

(node as any).hash = "095e500fc8347010599f1dd511e38976";

export default node;
